import { ApiClient } from "./api-client";

export function getUserBookings(userId, urlParams) {
  return ApiClient.getInstance().get('/booking/:id', { urlParams: { id: userId }, params: urlParams }).catch((error) => {
    console.error('Error fetching user bookings:', error);
    throw error;
  });
}

export function getAllBookings(queryParams) {
  return ApiClient.getInstance().get('/booking', { params: queryParams }).catch((error) => {
    console.error('Error fetching all bookings:', error);
    throw error;
  });
}

export function createBooking(userId, createBooking) {
  return ApiClient.getInstance().post('/booking/:id', createBooking, { urlParams: { id: userId } }).catch((error) => {
    console.error('Error creating user bookings:', error);
    throw error;
  });
}


export function updateBooking(updateBooking) {
  return ApiClient.getInstance().put('/booking/', updateBooking).catch((error) => {
    console.error('Error creating user bookings:', error);
    throw error;
  });
}

export function getAllowedExtensions(bookingId, roomId) {
  return ApiClient.getInstance().get('/booking/extend', { params: { bookingId, roomId } }).catch((error) => {
    console.error('Error fetching allowed extensions for booking:', error);
    throw error;
  });
}

export function updateExtendBooking(bookingId, interval) {
  return ApiClient.getInstance().put('/booking/extend', { bookingId: bookingId, interval: interval }).catch((error) => {
    console.error('Error fetching allowed extensions for booking:', error);
    throw error;
  });
}

export function deleteBooking(bookingId) {
  return ApiClient.getInstance().delete('/booking/:id', { urlParams: { id: bookingId } }).catch((error) => {
    console.error('Error creating user bookings:', error);
    throw error;
  });
}